import Catalog from '~/Catalog';

export const NO_OFFICE_ID = 'o---00000000-0000-0000-0000-000000000000';
export const NO_USER_ID = 'u---00000000-0000-0000-0000-000000000000';

export const TEXT = {
  settingsHeader: 'Instellingen',
  accountDescriptionHeader: 'Notitie voor callcenter',
  servicesHeader: 'Actieve diensten',
  rulesHeader: 'Regels',
  invalidLeadscoreNumber: 'Ongeldig leadscorenummer',
  invalidPhoneNumber: 'Ongeldig telefoonnummer',
  invalidMinLeadscore: 'Minimale leadscore moet tussen 0 en 100 liggen',
  markdownTemplateMakelaarsTooltip: 'Makelaars markdown template toepassen',
  markdownTemplateHypotheekAdvisorsTooltip:
    'Hypotheekadviseurs markdown template toepassen',
  makelaars: 'Makelaars',
  hypotheekAdvisors: 'Hypotheekadviseurs',
  markdownEditorLabel: 'Markdown',
  numberInputLabel: 'Voer een getal in tussen 0 en 100',
  tagInputHeader: 'Sluit contacten uit met deze tags',
  tagInputDescription:
    'Als het contact deze tags heeft, wordt er geen lead naar het callcenter gestuurd.',
  officeInputHeader: 'Sluit contacten uit van deze vestigingen',
  officeInputDescription:
    'Als het contact aan deze vestigingen is toegewezen, wordt er geen lead naar het callcenter gestuurd.',
  userInputHeader: 'Sluit contacten uit van deze gebruikers',
  userInputDescription:
    'Als het contact aan deze gebruikers is toegewezen, wordt er geen lead naar het callcenter gestuurd.',
  flynckHeader: 'Flynck instellingen',
  importSetupIDLabel: 'Import setup ID',
  contextIDLabel: 'Context ID',
  minLeadscoreHeader: 'Minimale leadscore',
  minLeadscoreDescription:
    'Minimale leadscore te bereiken om een lead naar het callcenter te sturen.',
  selectOfficesPlaceholder: 'Selecteer vestigingen',
  selectUsersPlaceholder: 'Selecteer gebruikers',
  noOfficeLabel: 'Geen vestiging',
  noUserLabel: 'Geen gebruiker',
  noAddressFound: 'Geen vestiging gevonden',
  successMessage: Catalog.genericSuccessMessage,
  errorMessage: Catalog.genericUnknownErrorMessageShort,
  noLocationsSelectedError: 'Selecteer locaties voor geselecteerde diensten',
  servicesV2NoLocationsError:
    'Selecteer minimaal één locatie voor elke dienst (account en vestigingen)',
  servicesV2NoCalendarsError:
    'Elke actieve dienst moet minimaal één agenda hebben (account en vestigingen)',
  servicesV2CalendarLinkRequired:
    "Agenda's van type Google of Overig moeten een geldige link hebben (https://...)",
  preview: 'Preview',
  flynkSettingsErrors: 'Flynk-instellingen mogen niet leeg zijn',
  emptyStringNotAllowed: 'Waarde mag niet leeg zijn',
  flynckSettingsWarning:
    'Pas deze instellingen alleen aan als je hier specifiek om wordt gevraagd.',
  accountNotActiveHeader: 'Pas op!',
  accountNotActiveWarning:
    'Je moet eerst LFA inschakelen voordat je deze instellingen kunt aanpassen.',
  callbackPhoneNumberHeader: 'Callcenter telefoonnummer',
  callbackPhoneNumberDescription:
    'Dit veld is verplicht om LeadAssist te activeren. Voer account telefoonnummer in als callcenter telefoonnummer niet bekend is.',
  phoneNumber: 'Telefoonnummer',
  servicesV2Header: 'Diensten V2',
  servicesV2Description:
    'Er zijn nog geen Diensten V2 geconfigureerd. Activeer Diensten V2 om de huidige diensten over te nemen als basis.',
  activateServicesV2: 'Diensten V2 activeren',
  removeServicesV2: 'Diensten V2 verwijderen',
  v1DisabledByV2:
    'Diensten V1 is niet meer actief. Beheer diensten via Diensten V2 hieronder.',
};

const emojiMap: Record<string, string> = {
  telephone_receiver: '📞',
  repeat: '🔁',
  exclamation: '❗',
  lock: '🔒',
};

const date = new Date().toLocaleDateString('nl-NL', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

export const MARKDOWN_TEMPLATE_MAKELAARS = `# ${emojiMap.telephone_receiver} Instructies voor afspraakplanning voor makelaars

## Specifieke instructies:
- Check werkgebied met adreschecker en wijs juiste kantoor + gebruiker toe
- Afspraken aankoop-leads vanaf €X 
- Afspraken van type X naar [Naam makelaar]

## Afspraak toewijzen:

- Verkopen of taxeren: Vind de verantwoordelijke vestiging en makelaar met adrescheck aan de linkerkant. 
- Kopen: Gebruik dan een adres waar iemand zich zou willen vestigen. 

## Contact voor afspraakbevestiging:
- Bevestig bij de toegewezen gebruiker.

## Agenda systeem:

- Realworks inlog gegevens: [username + wachtwoord]
- Directe link naar agenda: [link toevoegen]

## E-mail login:
- [E-mailadres + wachtwoord voor bevestigingen]
- [Waar moet ik inloggen bijv. Office, Gmail, etc]

---

### ${emojiMap.repeat} Na het Inplannen


  - Schrijf een notitie waarin je toelichting geeft over het gesprek, waar de afspraak plaatsvindt en andere bijzonderheden. 

---

### ${emojiMap.exclamation} Bijzondere Gevallen

- Geen geschikt moment beschikbaar? Noteer dit en informeer de klant.

---

### ${emojiMap.lock} Gegevensverwerking

- Behandel klantgegevens altijd vertrouwelijk
- Sla geen gegevens extern of buiten officiële systemen op

---

*Laatst bijgewerkt: ${date}*`;

export const MARKDOWN_TEMPLATE_HYPOTHEEK_ADVISORS = `# 📞 Instructies voor afspraakplanning voor Hypotheekadviseurs

## Specifieke instructies:
- Werkgebied checken is niet van toepassing. 

## Afspraak toewijzen:

- Contact is meestal al toegewezen aan juiste persoon, anders:
- Afspraken nazorg naar: [naam invullen]
- Afspraken nieuw advies naar: [naam invullen]

## Contact voor afspraakbevestiging:

- Bevestig bij de toegewezen gebruiker

## Agenda systeem:

- Directe link naar agenda: [link toevoegen]
- Realworks/Portefeuillesignalen/Elements [kies systeem] inlog gegevens: [username + wachtwoord]

## E-mail login:

- [E-mailadres + wachtwoord voor bevestigingen]
- [Waar moet ik inloggen bijv. Office, Gmail, etc]

---

### 🔁 Na het Inplannen

  - Schrijf een notitie waarin je toelichting geeft over het gesprek, waar de afspraak plaatsvindt en andere bijzonderheden. 

---

### ❗ Bijzondere Gevallen

- Geen geschikt moment beschikbaar? Noteer dit en informeer de klant.

---

### 🔒 Gegevensverwerking

- Behandel klantgegevens altijd vertrouwelijk
- Sla geen gegevens extern of buiten officiële systemen op

---

*Laatst bijgewerkt: ${date}*
`;
